import React, { useState } from "react"
import PhotoGallery from "react-photo-gallery"
import FsLightbox from "fslightbox-react"
import GalleryPortal from "components/GalleryPortal"

export type GalleryProps = {
  images: {
    src: string
    width: number
    height: number
  }[]
}

const Gallery = ({ images }: GalleryProps) => {
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 0,
  })

  const openLightbox = (event: React.MouseEvent, photos: { index: number }) => {
    event.preventDefault()
    event.stopPropagation()
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: photos.index + 1,
    })
  }

  return (
    <div>
      <PhotoGallery photos={images} onClick={openLightbox} />
      <GalleryPortal>
        <FsLightbox
          toggler={lightboxController.toggler}
          sources={images.map(image => image.src)}
          slide={lightboxController.slide}
        />
      </GalleryPortal>
    </div>
  )
}

export default Gallery
